import React, { useEffect, useState } from 'react';
import { ShoppingBagIcon } from 'lucide-react';
const CHECKOUT_URL = 'https://aromaticos.impultienda.ar/checkout/aromaticos';
type FloatingCTAProps = {
  triggerId: string;
};
export function FloatingCTA({
  triggerId
}: FloatingCTAProps) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const trigger = document.getElementById(triggerId);
    if (!trigger) return;

    // Show floating CTA only after the first CTA button has scrolled out of view
    const observer = new IntersectionObserver(([entry]) => {
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    }, {
      threshold: 0
    });
    observer.observe(trigger);
    return () => observer.disconnect();
  }, [triggerId]);
  return <div className={`fixed inset-x-0 bottom-0 z-50 px-3 pb-3 pt-2 transition-all duration-300 ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none translate-y-full opacity-0'}`} data-id="element-102" data-mp="38ap4wp5qtw9v">
      <div className="mx-auto max-w-md rounded-2xl bg-white/90 p-2 shadow-2xl shadow-[#3b3350]/25 backdrop-blur-md ring-1 ring-[#e4dbcc]" data-id="element-103" data-mp="2z1fs5oo4ft4b">
        <a href={CHECKOUT_URL} className="flex w-full items-center justify-between gap-3 rounded-xl bg-[#7c6aa8] px-4 py-3 text-white transition-colors hover:bg-[#6a5a95] active:scale-[0.98]" data-id="element-104" data-mp="332rhru6zweci">
          <span className="flex items-center gap-2" data-id="element-105" data-mp="2u8wd0n9scpxe">
            <ShoppingBagIcon className="w-5 h-5" data-id="element-106" data-mp="2fcx9lpxmfdyl" />
            <span className="text-left leading-tight" data-id="element-107" data-mp="2kd1o5aeyxym6">
              <span className="block text-[11px] font-medium text-white/80 line-through" data-id="element-108" data-mp="2kduptwz2lxxg">$162 USD</span>
              <span className="block text-sm font-extrabold" data-id="element-109" data-mp="26euxofccn0wj">Solo $12.99 USD</span>
            </span>
          </span>
          <span className="rounded-full bg-white/20 px-3 py-1.5 text-xs font-bold uppercase tracking-wide" data-id="element-110" data-mp="2behawos6gh5c">
            Lo quiero
          </span>
        </a>
      </div>
    </div>;
}